// Volume Discount Bar - Con progreso adaptativo para wrap
(function() {
  'use strict';

  class VolumeDiscountBar {
    constructor() {
      this.container = document.querySelector('.volume-discount-bar');
      if (!this.container) return;

      this.price = parseFloat(this.container.dataset.productPrice) || 0;
      this.discountTiers = [
        { amount: 125, discount: 10 },
        { amount: 250, discount: 15 },
        { amount: 450, discount: 20 },
        { amount: 700, discount: 25 },
        { amount: 1000, discount: 30 }
      ];

      this.currentStatus = document.getElementById('discount-current-status');
      this.baseCartTotal = 0;
      this.isUpdating = false;
      this.lastUpdate = 0;
      this.pollTimer = null;
      this.mutationObserver = null;
      
      this.init();
    }

    async init() {
      await this.updateCartTotal();
      this.bindEvents();
      this.updateDisplay();
      this.startPolling();
    }

    // Request optimizado
    async updateCartTotal() {
      const now = Date.now();
      if (this.isUpdating || (now - this.lastUpdate) < 300) return;

      this.isUpdating = true;
      this.lastUpdate = now;

      try {
        const response = await fetch('/cart.js', { cache: 'no-cache' });
        if (!response.ok) throw new Error('Network error');
        
        const cart = await response.json();
        this.baseCartTotal = cart.items.reduce((total, item) => {
          const unitPrice = item.original_price || item.price;
          return total + (unitPrice * item.quantity);
        }, 0) / 100;
      } catch (error) {
        console.warn('Cart update failed:', error.message);
      } finally {
        this.isUpdating = false;
      }
    }

    // Events simplificados
    bindEvents() {
      const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
          clearTimeout(timeout);
          timeout = setTimeout(() => func.apply(this, args), delay);
        };
      };

      const quickUpdate = debounce(this.handleCartUpdate, 200);
      const slowUpdate = debounce(this.handleCartUpdate, 500);

      const quantityInputs = document.querySelectorAll(
        'input[name="quantity"], .quantity-input input, [data-quantity-input]'
      );
      quantityInputs.forEach(input => {
        input.addEventListener('input', quickUpdate, { passive: true });
        input.addEventListener('change', quickUpdate, { passive: true });
      });

      document.addEventListener('cart:added', quickUpdate, { passive: true });
      document.addEventListener('cart:updated', slowUpdate, { passive: true });
      document.addEventListener('cart:change', slowUpdate, { passive: true });

      this.setupCartDrawer();
    }

    async handleCartUpdate() {
      await this.updateCartTotal();
      this.updateDisplay();
    }

    // Cart drawer simplificado
    setupCartDrawer() {
      const cartSelectors = [
        'cart-drawer', '#cart-drawer', '.cart-drawer', 
        '[data-cart-drawer]', '#CartDrawer'
      ];

      let cartDrawer = null;
      for (const selector of cartSelectors) {
        cartDrawer = document.querySelector(selector);
        if (cartDrawer) break;
      }

      if (!cartDrawer) return;

      const updateHandler = this.debounce(this.handleCartUpdate.bind(this), 300);

      if (window.MutationObserver) {
        try {
          this.mutationObserver = new MutationObserver(mutations => {
            const hasRelevantChanges = mutations.some(mutation => {
              if (mutation.type === 'childList') {
                return mutation.target.closest?.('.cart-items, cart-items');
              }
              if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                return mutation.target.matches?.('input[name="updates[]"], .qty-input__input');
              }
              return false;
            });

            if (hasRelevantChanges) updateHandler();
          });

          this.mutationObserver.observe(cartDrawer, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['value']
          });
        } catch (error) {
          console.warn('MutationObserver setup failed:', error);
        }
      }

      cartDrawer.addEventListener('click', (e) => {
        const target = e.target;
        if (target.matches('.btn--plus, .btn--minus, .qty-input__btn, .js-remove-item, .cart-item__remove')) {
          updateHandler();
        }
      }, { passive: true });

      cartDrawer.addEventListener('input', (e) => {
        if (e.target.matches('.qty-input__input, input[name="updates[]"]')) {
          updateHandler();
        }
      }, { passive: true });
    }

    // Polling reducido
    startPolling() {
      if (this.pollTimer) clearInterval(this.pollTimer);
      
      let lastTotal = this.baseCartTotal;
      let errorCount = 0;
      
      this.pollTimer = setInterval(async () => {
        if (this.isUpdating || errorCount > 2) return;

        try {
          const response = await fetch('/cart.js', { cache: 'no-cache' });
          const cart = await response.json();
          
          const currentTotal = cart.items.reduce((total, item) => {
            const unitPrice = item.original_price || item.price;
            return total + (unitPrice * item.quantity);
          }, 0) / 100;
          
          if (Math.abs(currentTotal - lastTotal) > 0.01) {
            lastTotal = currentTotal;
            this.baseCartTotal = currentTotal;
            this.updateDisplay();
          }
          errorCount = 0;
        } catch (error) {
          errorCount++;
        }
      }, 4000);
    }

    debounce(func, delay) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
      };
    }

    getCurrentQuantity() {
      const quantityInput = document.querySelector('input[name="quantity"]') 
        || document.querySelector('.quantity-input input')
        || document.querySelector('[data-quantity-input]');
      
      return quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
    }

    calculatePotentialTotal() {
      const quantity = this.getCurrentQuantity();
      return this.baseCartTotal + (quantity * this.price);
    }

    calculateSavings(total, discountPercent) {
      return total * (discountPercent / 100);
    }

    formatMoney(amount) {
      return amount.toFixed(2).replace(/\.00$/, '') + '€';
    }

    updateDisplay() {
      const total = this.calculatePotentialTotal();
      this.updateProgressBar(total);
      this.updateDiscountLevels(total);
      this.updateCurrentStatus(total);
      
      // Actualizar líneas dinámicas cuando cambia el tamaño de ventana
      if (window.innerWidth <= 380) {
        // Pequeño delay para asegurar que el layout se ha actualizado
        setTimeout(() => {
          const currentTierIndex = this.getCurrentTierIndex(total);
          this.createDynamicProgressLines(total, currentTierIndex);
        }, 100);
      }
    }

    // NUEVO: Obtener índice del tier actual
    getCurrentTierIndex(total) {
      let currentTierIndex = -1;
      for (let i = 0; i < this.discountTiers.length; i++) {
        if (total >= this.discountTiers[i].amount) {
          currentTierIndex = i;
        } else {
          break;
        }
      }
      return currentTierIndex;
    }

    // SISTEMA DE PROGRESO SIMPLIFICADO PERO EFECTIVO
    updateProgressBar(total) {
      let percentage = 0;
      const totalTiers = this.discountTiers.length;
      
      let currentTierIndex = -1;
      for (let i = 0; i < totalTiers; i++) {
        if (total >= this.discountTiers[i].amount) {
          currentTierIndex = i;
        } else {
          break;
        }
      }
      
      if (currentTierIndex === -1) {
        percentage = 0;
      } else if (currentTierIndex === totalTiers - 1) {
        percentage = 100;
      } else {
        const segmentSize = 100 / (totalTiers - 1);
        const basePercentage = currentTierIndex * segmentSize;
        
        const currentAmount = this.discountTiers[currentTierIndex].amount;
        const nextAmount = this.discountTiers[currentTierIndex + 1].amount;
        const segmentProgress = (total - currentAmount) / (nextAmount - currentAmount);
        
        percentage = basePercentage + (segmentProgress * segmentSize);
      }
      
      percentage = Math.min(Math.max(percentage, 0), 100);
      
      // Aplicar progreso tradicional para una fila
      document.documentElement.style.setProperty('--connecting-line-width', `${percentage}%`);
      document.documentElement.style.setProperty('--progress-percentage', `${percentage}%`);
      
      // Para pantallas pequeñas, usar indicador visual diferente
      const isWrapMode = window.innerWidth <= 380;
      if (isWrapMode) {
        this.updateWrapModeProgress(total, currentTierIndex, percentage);
      }
    }

    // PROGRESO SIMPLIFICADO PARA MODO WRAP
    updateWrapModeProgress(total, currentTierIndex, percentage) {
      // Limpiar líneas dinámicas previas
      this.removeDynamicProgressLines();
      
      // Crear indicador visual simple en la parte superior
      const container = document.querySelector('.discount-levels');
      if (!container) return;
      
      // Crear barra de progreso superior
      let progressIndicator = container.querySelector('.wrap-progress-indicator');
      if (!progressIndicator) {
        progressIndicator = document.createElement('div');
        progressIndicator.className = 'wrap-progress-indicator';
        progressIndicator.style.cssText = `
          position: absolute;
          top: -8px;
          left: 10%;
          right: 10%;
          height: 4px;
          background: #ecf0f1;
          border-radius: 2px;
          overflow: hidden;
          z-index: 3;
        `;
        
        const progressBar = document.createElement('div');
        progressBar.className = 'wrap-progress-bar';
        progressBar.style.cssText = `
          height: 100%;
          background: linear-gradient(90deg, #c48b29 0%, #d4a347 100%);
          border-radius: 2px;
          width: 0%;
          transition: width 0.8s ease;
        `;
        
        progressIndicator.appendChild(progressBar);
        container.appendChild(progressIndicator);
      }
      
      // Actualizar progreso
      const progressBar = progressIndicator.querySelector('.wrap-progress-bar');
      if (progressBar) {
        progressBar.style.width = `${percentage}%`;
      }
      
      // Actualizar estados visuales de marcadores
      this.updateWrapModeVisuals(total, percentage);
    }

    // VISUALES MEJORADOS PARA MODO WRAP
    updateWrapModeVisuals(total, percentage) {
      const markers = document.querySelectorAll('.level-marker');
      const discounts = document.querySelectorAll('.level-discount');
      
      markers.forEach((marker, index) => {
        const discount = discounts[index];
        const tierAmount = this.discountTiers[index].amount;
        const isCompleted = total >= tierAmount;
        const isActive = !isCompleted && (index === 0 || total >= this.discountTiers[index-1]?.amount);
        
        // Limpiar clases
        marker.classList.remove('completed', 'active');
        if (discount) discount.classList.remove('active');
        
        if (isCompleted) {
          marker.classList.add('completed');
          if (discount) discount.classList.add('active');
        } else if (isActive) {
          const proximity = total / tierAmount;
          if (proximity >= 0.3) {
            marker.classList.add('active');
          }
        }
      });
    }

    // SIMPLIFICADO: Solo limpiar indicadores de wrap
    removeDynamicProgressLines() {
      const existingIndicators = document.querySelectorAll('.wrap-progress-indicator, .dynamic-progress');
      existingIndicators.forEach(el => el.remove());
    }

    // NUEVO: Visuales especiales para modo wrap
    updateWrapModeVisuals(total, percentage) {
      const markers = document.querySelectorAll('.level-marker');
      
      markers.forEach((marker, index) => {
        const tierAmount = this.discountTiers[index].amount;
        const isCompleted = total >= tierAmount;
        const isActive = !isCompleted && (index === 0 || total >= this.discountTiers[index-1].amount);
        
        // Remover clases previas
        marker.classList.remove('completed', 'active');
        
        if (isCompleted) {
          marker.classList.add('completed');
        } else if (isActive && total / tierAmount >= 0.3) {
          marker.classList.add('active');
        }
        
        // Efecto adicional de "glow" basado en proximidad
        if (isActive && !isCompleted) {
          const proximity = total / tierAmount;
          const glowIntensity = Math.min(proximity * 100, 100);
          marker.style.boxShadow = `0 0 ${8 + glowIntensity/10}px rgba(196, 139, 41, ${0.4 + proximity * 0.4})`;
        } else if (!isCompleted) {
          marker.style.boxShadow = '';
        }
      });
    }

    updateDiscountLevels(total) {
      document.querySelectorAll('.discount-level').forEach((level, index) => {
        const marker = level.querySelector('.level-marker');
        const discount = level.querySelector('.level-discount');
        const tierAmount = this.discountTiers[index].amount;
        
        marker.classList.remove('active', 'completed');
        discount.classList.remove('active');
        
        if (total >= tierAmount) {
          marker.classList.add('completed');
          discount.classList.add('active');
        } else if (index === 0 || total >= this.discountTiers[index-1].amount) {
          if (total / tierAmount >= 0.5) {
            marker.classList.add('active');
          }
        }
      });
    }

    updateCurrentStatus(total) {
      if (!this.currentStatus) return;

      const currentTier = [...this.discountTiers].reverse().find(tier => total >= tier.amount);
      
      if (currentTier) {
        const currentSavings = this.calculateSavings(total, currentTier.discount);
        const nextTier = this.discountTiers.find(tier => total < tier.amount);
        
        let nextTierHtml = '';
        if (nextTier) {
          const amountNeeded = nextTier.amount - total;
          const potentialSavings = this.calculateSavings(nextTier.amount, nextTier.discount);
          nextTierHtml = `<span class="next-tier-info">Añade ${this.formatMoney(amountNeeded)} más para ${nextTier.discount}% (Ahorrarás ${this.formatMoney(potentialSavings)})</span>`;
        }
        
        this.currentStatus.innerHTML = `
          ¡${currentTier.discount}% de descuento activo!
          <span class="current-savings">💰 Ahorro actual: ${this.formatMoney(currentSavings)}</span>
          ${nextTierHtml}
        `;
      } else {
        const firstTier = this.discountTiers[0];
        const progress = Math.min((total / firstTier.amount) * 100, 100);
        const amountNeeded = firstTier.amount - total;
        const potentialSavings = this.calculateSavings(firstTier.amount, firstTier.discount);
        
        this.currentStatus.innerHTML = `
          ${progress.toFixed(0)}% hacia el primer descuento 
          <span class="current-savings">Total: ${this.formatMoney(total)}</span>
          <span class="next-tier-info">Añade ${this.formatMoney(amountNeeded)} más para ${firstTier.discount}% (Ahorrarás ${this.formatMoney(potentialSavings)})</span>
        `;
      }
    }

    destroy() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
      
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
        this.mutationObserver = null;
      }
      
      // Limpiar líneas dinámicas
      this.removeDynamicProgressLines();
    }
  }

  // Inicialización con listener de resize
  let discountBarInstance = null;

  function initDiscountBar() {
    if (discountBarInstance) {
      discountBarInstance.destroy();
    }
    discountBarInstance = new VolumeDiscountBar();
  }

  // NUEVO: Listener para cambios de tamaño de ventana
  let resizeTimeout;
  window.addEventListener('resize', () => {
    if (discountBarInstance) {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        discountBarInstance.updateDisplay();
      }, 150);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiscountBar);
  } else {
    initDiscountBar();
  }

  document.addEventListener('shopify:section:load', initDiscountBar);

  window.addEventListener('beforeunload', () => {
    if (discountBarInstance) {
      discountBarInstance.destroy();
    }
  });

})();